import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { IAppState } from "../store";
import { AuthStates } from "../reducers/auth/types";

interface Props {
  component: any;
  setAuthDialogOpen: (val: boolean) => void;
  path: string;
  authDialogOpen: boolean;
  exact?: boolean;
}

const ProtectedRoute = ({
  component: Component,
  setAuthDialogOpen,
  authDialogOpen,
  ...rest
}: Props) => {
  const authState = useSelector((state: IAppState) => state.authReducer);
  const isSignedIn = authState.state === AuthStates.SIGNED_IN;

  useEffect(() => {
    if (!isSignedIn) {
      setAuthDialogOpen(true);
    }
  }, [isSignedIn, setAuthDialogOpen]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isSignedIn) return null;
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;